import styled from "styled-components";

const SvgOne = () => (
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.10873 0.980469C3.89134 0.980469 3.68286 1.05712 3.52914 1.19355C3.37543 1.32998 3.28907 1.51502 3.28907 1.70796V2.43546H2.46941C2.03463 2.43546 1.61766 2.58875 1.31023 2.86162C1.00279 3.13448 0.830078 3.50456 0.830078 3.89045V11.1654C0.830078 11.5513 1.00279 11.9214 1.31023 12.1942C1.61766 12.4671 2.03463 12.6204 2.46941 12.6204H12.3054C12.7401 12.6204 13.1571 12.4671 13.4645 12.1942C13.772 11.9214 13.9447 11.5513 13.9447 11.1654V3.89045C13.9447 3.50456 13.772 3.13448 13.4645 2.86162C13.1571 2.58875 12.7401 2.43546 12.3054 2.43546H11.4857V1.70796C11.4857 1.51502 11.3993 1.32998 11.2456 1.19355C11.0919 1.05712 10.8834 0.980469 10.666 0.980469C10.4487 0.980469 10.2402 1.05712 10.0865 1.19355C9.93273 1.32998 9.84638 1.51502 9.84638 1.70796V2.43546H4.9284V1.70796C4.9284 1.51502 4.84204 1.32998 4.68832 1.19355C4.53461 1.05712 4.32612 0.980469 4.10873 0.980469ZM4.10873 4.61795C3.89134 4.61795 3.68286 4.69459 3.52914 4.83103C3.37543 4.96746 3.28907 5.1525 3.28907 5.34544C3.28907 5.53839 3.37543 5.72343 3.52914 5.85986C3.68286 5.99629 3.89134 6.07294 4.10873 6.07294H10.666C10.8834 6.07294 11.0919 5.99629 11.2456 5.85986C11.3993 5.72343 11.4857 5.53839 11.4857 5.34544C11.4857 5.1525 11.3993 4.96746 11.2456 4.83103C11.0919 4.69459 10.8834 4.61795 10.666 4.61795H4.10873Z"
    />
  </svg>
);
const SvgTwo = () => (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.46911 0.957031C6.29854 0.957136 6.13137 1.0117 5.98632 1.11463C5.84126 1.21755 5.72405 1.36476 5.64781 1.53977L4.98268 3.06459H1.87571C1.63206 3.06459 1.39839 3.17561 1.22611 3.37324C1.05382 3.57086 0.957031 3.83889 0.957031 4.11837C0.957031 4.39785 1.05382 4.66588 1.22611 4.8635C1.39839 5.06113 1.63206 5.17215 1.87571 5.17215V15.7099C1.87571 16.2689 2.06929 16.805 2.41386 17.2002C2.75843 17.5955 3.22577 17.8175 3.71307 17.8175H11.0625C11.5498 17.8175 12.0171 17.5955 12.3617 17.2002C12.7063 16.805 12.8999 16.2689 12.8999 15.7099V5.17215C13.1435 5.17215 13.3772 5.06113 13.5495 4.8635C13.7218 4.66588 13.8185 4.39785 13.8185 4.11837C13.8185 3.83889 13.7218 3.57086 13.5495 3.37324C13.3772 3.17561 13.1435 3.06459 12.8999 3.06459H9.79289L9.12777 1.53977C9.05152 1.36476 8.93431 1.21755 8.78926 1.11463C8.6442 1.0117 8.47703 0.957136 8.30647 0.957031H6.46911ZM4.63175 7.27971C4.63175 7.00023 4.72854 6.7322 4.90082 6.53457C5.07311 6.33695 5.30678 6.22593 5.55043 6.22593C5.79408 6.22593 6.02775 6.33695 6.20003 6.53457C6.37232 6.7322 6.46911 7.00023 6.46911 7.27971V13.6024C6.46911 13.8819 6.37232 14.1499 6.20003 14.3475C6.02775 14.5451 5.79408 14.6562 5.55043 14.6562C5.30678 14.6562 5.07311 14.5451 4.90082 14.3475C4.72854 14.1499 4.63175 13.8819 4.63175 13.6024V7.27971ZM9.22515 6.22593C8.9815 6.22593 8.74783 6.33695 8.57554 6.53457C8.40326 6.7322 8.30647 7.00023 8.30647 7.27971V13.6024C8.30647 13.8819 8.40326 14.1499 8.57554 14.3475C8.74783 14.5451 8.9815 14.6562 9.22515 14.6562C9.4688 14.6562 9.70247 14.5451 9.87475 14.3475C10.047 14.1499 10.1438 13.8819 10.1438 13.6024V7.27971C10.1438 7.00023 10.047 6.7322 9.87475 6.53457C9.70247 6.33695 9.4688 6.22593 9.22515 6.22593Z"
    />
  </svg>
);
const SvgThree = () => (
  <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.259766 1.61688C0.259766 1.3072 0.382084 1.0102 0.599813 0.79122C0.817541 0.57224 1.11284 0.449219 1.42076 0.449219H3.74274C4.05066 0.449219 4.34596 0.57224 4.56369 0.79122C4.78142 1.0102 4.90374 1.3072 4.90374 1.61688C4.90374 1.92657 4.78142 2.22357 4.56369 2.44255C4.34596 2.66153 4.05066 2.78455 3.74274 2.78455H1.42076C1.11284 2.78455 0.817541 2.66153 0.599813 2.44255C0.382084 2.22357 0.259766 1.92657 0.259766 1.61688ZM0.259766 7.45521C0.259766 7.14552 0.382084 6.84852 0.599813 6.62954C0.817541 6.41056 1.11284 6.28754 1.42076 6.28754H8.38671C8.69463 6.28754 8.98993 6.41056 9.20766 6.62954C9.42539 6.84852 9.5477 7.14552 9.5477 7.45521C9.5477 7.76489 9.42539 8.06189 9.20766 8.28087C8.98993 8.49985 8.69463 8.62287 8.38671 8.62287H1.42076C1.11284 8.62287 0.817541 8.49985 0.599813 8.28087C0.382084 8.06189 0.259766 7.76489 0.259766 7.45521ZM0.259766 13.2935C0.259766 12.9838 0.382084 12.6868 0.599813 12.4679C0.817541 12.2489 1.11284 12.1259 1.42076 12.1259H15.3527C15.6606 12.1259 15.9559 12.2489 16.1736 12.4679C16.3913 12.6868 16.5137 12.9838 16.5137 13.2935C16.5137 13.6032 16.3913 13.9002 16.1736 14.1192C15.9559 14.3382 15.6606 14.4612 15.3527 14.4612H1.42076C1.11284 14.4612 0.817541 14.3382 0.599813 14.1192C0.382084 13.9002 0.259766 13.6032 0.259766 13.2935Z"
    />
  </svg>
);
const SvgFour = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z" />
  </svg>
);

const StyledGrid = styled.div`
  display: flex;
  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
`;
const StyledLeft = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  text-align: left;
  @media screen and (max-width: 992px) {
    text-align: center;
    margin-bottom: 2rem;
  }
  @media screen and (max-width: 768px) {
    text-align: left;
  }
  h3 {
    font-size: 1.6rem;
    line-height: 2rem;
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
`;
const StyledRight = styled.div`
  flex: 3;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 0 4rem;
  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;
const StyledRow = styled.div`
  display: flex;
  margin: ${(props) => props.margin || "0 -3rem 0 3rem"};
  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin: 0;
  }
`;
const StyledRightItem = styled.div`
  background: var(--raised-background-color);
  border: 1px solid var(--background-color);
  border-radius: 5px;
  margin: 1rem;
  flex: 1 1 50%;
  position: relative;
  padding: 2rem;
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0;
  }
  svg {
    height: 2rem;
    width: 2rem;
    fill: #6c8ef8;
  }
  @media screen and (max-width: 768px) {
    margin: 0.5rem 0;
  }
`;
const StyledBlobOne = styled.div`
  position: absolute;
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  left: -3rem;
  bottom: -3rem;
  background: linear-gradient(180deg, #9d7de9 0%, #6890fa 100%);
`;
const StyledBlobTwo = styled.div`
  position: absolute;
  z-index: -1;
  width: 8rem;
  height: 8rem;
  border-radius: 8rem;
  right: -3rem;
  top: -3rem;
  background: linear-gradient(180deg, #9d7de9 0%, #6890fa 100%);
`;

const Grid = () => {
  return (
    <StyledGrid>
      <StyledLeft>
        <h3>Scheduled deletion, preview, deletion or complete wipe modes.</h3>
        <div>
          You have the option to create a set of rules before deletion, look over what&apos;s
          getting targeted before you remove it, create a schedule of when you want it gone, or even
          go for the nuclear option and delete everything immediately.
        </div>
      </StyledLeft>
      <StyledRight>
        <StyledRow margin="0 0 0 0">
          <StyledRightItem>
            <h3>
              Specify rules of deletion <SvgThree />
            </h3>
            <div>Tailor your deletion to specific dates, categories and more.</div>
          </StyledRightItem>
          <StyledRightItem>
            <h3>
              Complete Deletion <SvgTwo />
            </h3>
            <div>Wipe out everything.</div>
            <StyledBlobTwo />
          </StyledRightItem>
        </StyledRow>
        <StyledRow>
          <StyledRightItem>
            <h3>
              Scheduled Deletion <SvgOne />
            </h3>
            <div>Pick the time and date for removal</div>
            <StyledBlobOne />
          </StyledRightItem>
          <StyledRightItem>
            <h3>
              Preview Mode <SvgFour />
            </h3>
            <div>Make sure nothing is getting caught in the crossfire.</div>
          </StyledRightItem>
        </StyledRow>
      </StyledRight>
    </StyledGrid>
  );
};

const StyledSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
  align-items: center;
  padding: 1rem 2rem;
  h2 {
    line-height: 4rem;
    font-size: 3.375rem;
    font-weight: 700;
    width: 100%;
    text-align: center;
    margin-bottom: 0;
    @media screen and (max-width: 1280px) {
      margin: 2rem 0 0 0;
    }
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
  p {
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 4rem;
    @media screen and (max-width: 768px) {
      text-align: left;
      margin-bottom: 1rem;
    }
  }
`;

const SubHero = () => {
  return (
    <StyledSection>
      <StyledWrapper>
        <Grid />
      </StyledWrapper>
    </StyledSection>
  );
};

export default SubHero;
